export interface IPolicy {
    raterName: string
    mgaName: string
    leadSource: any
    leadSourceBusinessName: any
    rateCall: string
    policyNumber: any
    agencyCode: string
    username: any
    lob: number
    ratedState: string
    effectiveDate: string
    expirationDate: string
    term: number
    insuredFirstName: string
    insuredMiddleInitial: any
    insuredLastName: string
    insuredSuffix: any
    secondInsuredFirstName: any
    secondInsuredMiddleInitial: any
    secondInsuredLastName: any
    secondInsuredSuffix: any
    emailAddress: string
    addresses: Address[] | undefined
    phoneNumbers: PhoneNumber[]
    PayPlan: {}
    isPaperless: boolean
    isNonOwners: boolean
    hasPriorCoverage: boolean
    has131Lapse: boolean
    hasNoLapse: boolean
    hasGtr31Lapse: boolean
    previousCompany: string
    previousExpirationDate: string
    priorMonthsInsured: number
    priorBiLimit: string
    isEft: boolean
    isRecurringEft: boolean
    isGarageSameAsMailing: boolean
    isHomeOwner: boolean
    isMultiCarHouseHold: boolean
    creditScore: number
    estimatedCreditScore: string
    rewriteReason: any
    renewalCount: any
    lengthOfResidency: any
    homeOwnerType: string
    tortOption: any
    vehicles: Vehicle[]
    drivers: Driver[]
    limits: Limit[]
    flags: Flag[]
    integrationId: string
  }

  export class Policy implements IPolicy {
      constructor(){
        
      }

      raterName: string = "";
      mgaName: string = "";
      leadSource: string = "";
      leadSourceBusinessName: string  = "";
      rateCall: string = "";
      policyNumber: string  = "";
      agencyCode: string = "";
      username: string  = "";
      lob: number = 1;
      ratedState: string = "";
      effectiveDate: string = "";
      expirationDate: string = "";
      term: number = 6;
      insuredFirstName: string = "";
      insuredMiddleInitial: string  = "";
      insuredLastName: string = "";
      insuredSuffix: string  = "";
      secondInsuredFirstName: string  = "";
      secondInsuredMiddleInitial: string  = "";
      secondInsuredLastName: string  = "";
      secondInsuredSuffix: string  = "";
      emailAddress: string  = "";
      addresses: Address[] = [];
      phoneNumbers: PhoneNumber[] = [];
      PayPlan: any = {};
      isPaperless: boolean = false;
      isNonOwners: boolean = false;
      hasPriorCoverage: boolean = false;
      has131Lapse: boolean = false;
      hasNoLapse: boolean = false;
      hasGtr31Lapse: boolean = false;
      previousCompany: string = "";
      previousExpirationDate: string = "";
      priorMonthsInsured: number = 0;
      priorBiLimit: string = "";
      isEft: boolean = false;
      isRecurringEft: boolean = false;
      isGarageSameAsMailing: boolean = false;
      isHomeOwner: boolean = false;
      isMultiCarHouseHold: boolean = false;
      creditScore: number = 0;
      estimatedCreditScore: string = "";
      rewriteReason: string = "";
      renewalCount: number = 0;
      lengthOfResidency: string = "";
      homeOwnerType: string = "";
      tortOption: string = "";
      vehicles: Vehicle[] = [];
      drivers: Driver[] = [];
      limits: Limit[] = [];
      flags: Flag[] = [];
      integrationId: string = "";
  }
  
  export interface IAddress {
    type: "mailing" | "garaging" | undefined
    streetName: string
    city: string
    state: string
    zip: string
    county: string
  }

  export class Address implements IAddress {
    type: "mailing" | "garaging" | undefined
    streetName: string = ""
    city: string = ""
    state: string = ""
    zip: string = ""
    county: string = ""
  }
  
  export interface IPhoneNumber {
    type: "Home" | "Mobile" | "Work" | undefined
    number: string
  }
  
  export class PhoneNumber implements IPhoneNumber {
    type: "Home" | "Mobile" | "Work" | undefined
    number: string = ""
  }

  export interface IRatingLienHolder {
    lienHolderNumber: number;
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    faxNumber: string;
    emailAddress: string;
}

export class RatingLienHolder implements IRatingLienHolder {
  lienHolderNumber: number = 0;
  name: string = "";
  address: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  phoneNumber: string = "";
  faxNumber: string = "";
  emailAddress: string = "";
}
  
  export interface IVehicle {
    carNumber: number 
    vin: string
    year: number
    make: string
    model: string
    bodyStyle: string
    costNew: number
    amountCustom: number
    annualMileage: number
    isIncludeAtRenewal: boolean
    ownershipType: string
    statedAmount: number
    lengthOfOwnership: string
    aebCode: string
    blindSpotCode: string
    restraintCode: string
    Mileage: any
    lienHolders: RatingLienHolder | null | undefined
    coverageLimits: any[]
    flags: Flag[]
    ratedOperator: any
  }


  

  export class Vehicle implements IVehicle {
    carNumber: number = 0
    vin: string = ""
    year: number = 0
    make: string = ""
    model: string  = ""
    bodyStyle: string  = ""
    costNew: number = 0.0
    amountCustom: number = 0.0
    annualMileage: number = 0
    isIncludeAtRenewal: boolean = false
    ownershipType: string = ""
    statedAmount: number = 0
    lengthOfOwnership: string = ""
    aebCode: string = ""
    blindSpotCode: string = ""
    restraintCode: string = ""
    Mileage: any
    lienHolders: any 
    coverageLimits: any[] = []
    flags: Flag[] = []
    ratedOperator: any


    public build(currentVehicleCount: number, 
      vin: string,
      year: number,
      make: string,
      model: string,
      style: string,
      ownershipType: string,
      annualMileage: number){
      
        this.carNumber = currentVehicleCount + 1;
        this.vin = vin;
        this.year = year;
        this.make = make;
        this.model = model;
        this.bodyStyle = style;
        this.costNew = 0;
        this.amountCustom = 0;
        this.annualMileage = annualMileage;
        this.isIncludeAtRenewal = false;
        this.ownershipType = ownershipType;
        // TODO: i think this needs to be added to UI
        this.statedAmount = 0;
        this.lengthOfOwnership = "";
        this.aebCode = "";
        this.blindSpotCode = "";
        this.restraintCode = "";
        this.Mileage = "";
        this.lienHolders = null;
        this.coverageLimits = [];
        this.flags= [];
        this.ratedOperator = null;
        
      return this;
    }

    public getVehicle(vehicles: Vehicle[], carNumber: number){
      var clonedVehicles = [...(vehicles)];
      var index = (clonedVehicles?.findIndex(m=> m.carNumber == parseInt(carNumber.toString())) ?? -1);

      var foundVehicle = index === -1 ? new Vehicle() : (clonedVehicles ?? [])[(index ?? 0)];

      return foundVehicle;
    }
  }
  
  export interface Mileage {
    UsageType: string
    Miles: number
  }

  export interface IDriver {
    driverNumber: number
    firstName: string
    middleInitial: string
    lastName: string
    suffix: string
    gender: string
    dob: Date | undefined
    age: number
    licenseNum: string
    licenseState: string
    licensedDate: string
    relation: string
    totalPoints: number
    violationCount: number
    isIncludeAtRenewal: boolean
    isMarried: boolean
    isExcluded: boolean
    status: string
    licenseStatus: string
    educationCode: string
    listOnlyOption: string
    occupationGroup: string
    occupationCode: string
    flags: any[]
    violations: any[]
  }
  
  export class Driver implements IDriver {
    driverNumber: number
    firstName: string = ""
    middleInitial: string = ""
    lastName: string = ""
    suffix: string = ""
    gender: string = ""
    dob: Date | undefined
    age: number = 0
    licenseNum: string = ""
    licenseState: string = ""
    licensedDate: string = ""
    relation: string = ""
    totalPoints: number = 0
    violationCount: number = 0
    isIncludeAtRenewal: boolean = false
    isMarried: boolean = false
    isExcluded: boolean = false
    status: string = ""
    licenseStatus: string = ""
    educationCode: string = ""
    listOnlyOption: string = ""
    occupationGroup: string = ""
    occupationCode: string = ""
    flags: Flag[] = []
    violations: any[] = []

    constructor(){
      this.driverNumber = 0;
    }

    public get(drivers: Driver[], driverNumber: number){
      var cloned = [...(drivers)];
      var index = (cloned?.findIndex(m=> m.driverNumber == driverNumber) ?? 0);

      var foundVehicle = index === -1 ? new Driver() : cloned[index];

      return foundVehicle;
    }
  }
  
  export interface ILimit {
    type: string
    name: string
    limit: string
  }
  
  export class Limit implements ILimit {
    type: string = "";
    name: string = "";
    limit: string = "";

  }
  
  export interface IFlag {
    name: string
    value: string
    hasFlag: boolean
    indexNumber: number
    attributes: any[]
  }

  export class Flag implements IFlag {
    name: string = ""
    value: string = ""
    hasFlag: boolean = false
    indexNumber: number = 0
    attributes: any[] = []
  }
  